
import { mapActions } from 'vuex';
import ArrowIcon from '~/components/ui/icons/ArrowIcon.vue';
import { isMobileResponsive } from '@/utils/mixins';
import CustomModal from '~/components/ui/molecule/CustomModal.vue';

export default {
  name: 'TransactionTypesModal',
  components: {
    ArrowIcon,
    CustomModal,
  },
  mixins: [isMobileResponsive],
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    portfolioOperationModal: {
      type: Object,
      required: true,
    },
  },
  computed: {
    showPastTransactionSection() {
      if (!this.portfolioOperationModal?.portfolio) return;
      return this.portfolioOperationModal.portfolio.isPublic === false;
    },
  },
  methods: {
    ...mapActions('modals', ['toggleShowTransactionTypesModal']),
    handleShowTransactionTypesModal() {
      this.$emit('onShowTransactionTypesModal');
      this.toggleShowTransactionTypesModal(false);
    },
  },
};
